<div class="ml-[220px] flex flex-col gap-8 py-6">
  <div class="inline-flex w-full items-end justify-between px-6">
    <h2 class="text-primary font-['Inter'] text-3xl font-bold" i18n="@@categoriesTitle">Categories</h2>
  </div>

  @if (errorMessage()) {
    <div class="text-danger-text px-6 text-center text-lg">{{ errorMessage() }}</div>
  } @else {
    <div class="flex flex-wrap justify-start gap-8 px-8">
      @if (categories) {
        @for (category of categories.list; track category.id) {
          <div
            (click)="viewCategory(category)"
            class="group hover-shadow-primary-15 relative flex h-64 w-52 cursor-pointer flex-col items-center justify-between overflow-hidden rounded-[2.5rem] border border-gray-50 bg-white p-6 shadow-[0_10px_40px_rgba(0,0,0,0.04)] transition-all duration-500 hover:-translate-y-3">
            <div
              class="relative z-10 flex h-36 w-36 items-center justify-center overflow-hidden rounded-3xl bg-gray-50/50 shadow-inner transition-all duration-500 group-hover:bg-white">
              @let imageData = categoryImages.get(category.id);

              @if (imageData && imageData.isImage) {
                <img
                  [src]="imageData.url"
                  class="h-full w-full scale-95 object-contain p-2 transition-transform duration-700 group-hover:scale-110" />
              } @else {
                <app-categories-icon />
              }
            </div>

            <div class="flex flex-1 items-center justify-center pt-2">
              <span
                class="group-hover-text-primary relative z-10 line-clamp-2 px-2 text-center text-lg leading-snug font-bold text-gray-800 transition-colors duration-300">
                {{ getLocalizedTitle(category) }}
              </span>
            </div>

            <div
              class="bg-card-glow absolute -right-14 -bottom-14 h-40 w-40 rounded-full blur-3xl transition-transform duration-700 group-hover:scale-150"></div>

            <div
              class="bg-card-underline absolute bottom-0 left-0 h-2 w-0 rounded-full transition-all duration-500 group-hover:w-full"></div>
          </div>
        }
      }
    </div>
  }
</div>
